export default __webpack_public_path__ + "static/media/imagery.6fcee3d2.jpg";